import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import SchoolIcon from '@mui/icons-material/School';

export default function TeacherCourseMapping() {

  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [issaved, setissaved] = useState(false);
  const [semester_id, setSemester] = useState([]);
  const [getActiveEvents, setActiveEvents] = useState(false);
  const [getActiveStatus, setActiveStatus] = useState(false);
  const [getEventMsg, setEventMsg] = useState(false);
  const [activeSemesterId, setActiveSemesterId] = useState(null);
  const [getCourseData, setCourseData] = useState([]);
  const [getAllCourseStatusData, setAllCourseStatusData] = useState(false);
  const [courseDiciplineNameData, setCourseDiciplineNameData] = useState([]);
  const [collegeDiciplineSchemeID, setCollegeDiciplineSchemeID] = useState([]);
  const [courseDiciplineIDData, setCourseDiciplineIDData] = useState([]);
  const [courseDiciplineTypeData, setCourseDiciplineTypeData] = useState([]);
  const [collegeDiciplineTypeData, setCollegeDiciplineTypeData] = useState([]);
  const [selectedUserOptions, setSelectedUserOptions] = useState({});
  const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
  const [getCourseMappingStatusSummaryData, setCourseMappingStatusSummaryData] = useState([]);
  const [usersDataListInSeat, setUsersDataListInSeat] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [facultyMap, setFacultyMap] = useState({});

  {/*------------Data Table--------------*/ }
  const [searchTerm, setSearchTerm] = useState("");
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  {/*------------------------------------*/ }

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/sfa/");
  }

  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    if (admissionYear && semester_id?.value) {
      const fetchActiveEvents = async () => {
        try {
          const response = await http.get('getActiveEvents', {
            params: { event_id: 19 }
          });

          const event = response.data[0];

          setActiveEvents(event);

          setActiveStatus(
            event.admission_year === admissionYear.value &&
            event.semester_id === semester_id.value &&
            event.status == "active"
          );
          setEventMsg(
            event.admission_year === admissionYear.value &&
            event.semester_id === semester_id.value &&
            event.status != "active"
          );

        } catch (error) {
          setActiveEvents(null);
          setActiveStatus(false);
          setEventMsg(false);
          //console.log(error);
          const status1 = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";
          const status = error.response?.status;
          const errorCode = error.response?.data?.status_code;

          // if (status === 500 || error.response?.data?.status_code === "ERR5") {
          //   toast.error(message);
          // } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          //   toast.error("Invalid Token");
          //   setTimeout(() => navigate("/sfa/"), 5000);
          // } else {
          //   toast.error(message);
          // }
          if (message.includes('Attempt to read property "user_id"')) {
            toast.error("Session expired. Please log in again.");
            setTimeout(() => navigate("/sfa/"), 3000);
          }
          else if ((status === 500 && message.includes('user_id')) || message.includes('Attempt to read property "user_id"')) {
            toast.error("Session expired. Please log in again.");
            setTimeout(() => navigate("/sfa/"), 3000);
          } else if (status === 403 && errorCode === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/sfa/"), 3000);
          } else {
            toast.error(message);
          }
        }
      };

      fetchActiveEvents();
    }
  }, [admissionYear, semester_id]);

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/College/getSFASideActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        setAdmissionYears([]);
        console.error("Error fetching admission years:", error);
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 5000);
        } else {
          toast.error(message);
        }
      }
    };
    fetchAdmissionYears();
  }, []);

  const handleAdmissionYearChange = (selectedOption) => {
    setAdmissionYear(selectedOption);
  };

  const handleSemesterChange = (selectedOption) => {
    setSemester(selectedOption);
  };

  // Fetch Event Based on Selection
  useEffect(() => {
    const fetchActiveEvents = async () => {
      if (admissionYear && semester_id) {
        try {
          const response = await http.get('getActiveEvents', {
            params: { event_id: 19 }
          });

          const matchedEvent = response.data.find(event =>
            event.admission_year === admissionYear.value &&
            event.semester_id === semester_id.value &&
            event.status === "active"
          );

          if (matchedEvent) {
            setActiveEvents(matchedEvent);
            const isActive = matchedEvent.status === "active";
            setActiveSemesterId(matchedEvent.semester_id); // store active semester
            setEventMsg(false);
          } else {
            setActiveSemesterId(null);

            setEventMsg(false);
          }
        } catch (error) {
          console.log("API Error:", error);
          setActiveSemesterId(null);

          setEventMsg(false);
          // const status = error.response?.data?.http_status;
          // const message = error.response?.data?.message || "An error occurred";

          // if (status === 500 || error.response?.data?.status_code === "ERR5") {
          //   toast.error(message);
          // } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          //   toast.error("Invalid Token");
          //   setTimeout(() => navigate("/sfa/"), 5000);
          // } else {
          //   toast.error(message);
          // }
          const status1 = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";
          const status = error.response?.status;
          const errorCode = error.response?.data?.status_code;

          if (message.includes('Attempt to read property "user_id"')) {
            toast.error("Session expired. Please log in again.");
            setTimeout(() => navigate("/sfa/"), 3000);
          }
          else if ((status === 500 && message.includes('user_id')) || message.includes('Attempt to read property "user_id"')) {
            toast.error("Session expired. Please log in again.");
            setTimeout(() => navigate("/sfa/"), 3000);
          } else if (status === 403 && errorCode === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/sfa/"), 3000);
          } else {
            toast.error(message);
          }
        }
      } else {
        setActiveSemesterId(null);
        setEventMsg(false);
      }
    };

    fetchActiveEvents();
  }, [admissionYear, semester_id]);

  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getSFASideCollegeDisciplines`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data);
      }
      catch (error) {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 5000);
        } else {
          toast.error(message);
        }

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/sfa/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const getCourseMappingStatusSummary = async () => {
      http.get('/College/getCourseMappingStatusSummary', {
        params: {
          college_id: cid,
          admissionyear: admissionYear.value,
          semester_id: semester_id.value,

        },
      }).then((response) => {
        setCourseMappingStatusSummaryData(response.data);
      }).catch((error) => {
        setCourseMappingStatusSummaryData([]);
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 5000);
        } else {
          toast.error(message);
        }
      });
    };
    if (cid && admissionYear && semester_id.value) {

      getCourseMappingStatusSummary();
    }


  }, [admissionYear, semester_id.value, issaved]);

  useEffect(() => {
    const getSFASideCollegeCourseForTeacher = async () => {
      http.get('/College/getSFASideCollegeCourseForTeacher', {
        params: {
          college_id: cid,
          admissionyear: admissionYear.value,
          semester_id: semester_id.value,

        },
      })
        .then((response) => {
          setCourseData(response.data.course);
          setCourseDiciplineNameData(response.data.discipline_name);
          setCourseDiciplineIDData(response.data.selected_discipline_id);
          setCourseDiciplineTypeData(response.data.college_course_type);
          setCollegeDiciplineTypeData(response.data.college_discipline_type);
          setCollegeDiciplineSchemeID(response.data.scheme_id);

          const courses = response.data.course;
          // Check if all course_status are approved
          const allApproved = courses.every(course => course.course_status === 'approved');

          if (allApproved) {
            setAllCourseStatusData('allApproved'); // or true
          } else {
            setAllCourseStatusData('notAllApproved'); // or false
          }

        }).catch((error) => {
          setCourseData([]);
          setCourseDiciplineNameData([]);
          setCourseDiciplineIDData([]);
          setCollegeDiciplineSchemeID([]);
          setAllCourseStatusData(false);
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/sfa/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };
    if (cid && admissionYear && semester_id.value) {

      getSFASideCollegeCourseForTeacher();
    }

  }, [admissionYear, semester_id.value, issaved]);


  const handleUserChange = (selectedOption, courseId) => {
    setSelectedUserOptions(prev => ({
      ...prev,
      [courseId]: selectedOption || []
    }));
  };


  useEffect(() => {
    const fetchCollegeTeachersList = async () => {
      try {
        const response = await http.get(`/College/getCollegerTeacher`, {
          params: {
            college_id: cid,
            admissionyear: admissionYear.value,
            semester_id: semester_id.value,
            course_type: courseDiciplineTypeData

          },
        });

        setCollegeTeacherData(response.data);



        // Create a lookup dictionary to pass to backend
        const facultyMap = {};
        response.data.forEach(u => {
          facultyMap[u.fac_id] = u;   // store full obj by fac_id
        });
        setFacultyMap(facultyMap);




        const selected = {};

        getCourseData.forEach(course => {
          const matchedUsers = response.data.filter(user =>
            user.courses.includes(course.course_id)
          );

          if (matchedUsers.length > 0) {
            selected[course.course_id] = matchedUsers.map(user => ({
              value: user.user_id,
              label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
              fac_id: user.fac_id
            }));
          }
        });

        setSelectedUserOptions(selected);

        //console.log("selectedUserOptions", selectedUserOptions);

      }
      catch (error) {
        setCollegeTeacherData([]);
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/sfa/");
          }, 5000);

        }
        if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/sfa/");
          }, 5000);

        }

        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };
    if (getCourseData.length > 0) {

      fetchCollegeTeachersList();
    }
  }, [getCourseData, courseDiciplineTypeData]);

  {/*------Data Table------*/ }

  $('#collapseOne').on('shown.bs.collapse', () => {
    setTimeout(() => {
      if (dataTableRef.current) {
        dataTableRef.current.columns.adjust().draw();
      }
    }, 300); // wait a bit after accordion opens
  });

  const filteredUsers = usersDataListInSeat
    .filter((user) =>
      `${user.user_id} ${user.name} ${user.email} ${user.section_name}`.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;
      const valA = a[sortColumn];
      const valB = b[sortColumn];
      if (valA < valB) return sortOrder === "asc" ? -1 : 1;
      if (valA > valB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  {/*--------------Data Table End---------------------*/ }


  const handlefirstsubmit = () => {

    if (getAllCourseStatusData === 'allApproved') {
      toast.info("Courses are already approved.");
      return; // Do nothing further
    }
    setFirstSubmit(!isFirstSubmit);

  }
  const handleSubmitData = (e) => {

    e.preventDefault();
    setFirstSubmit(!isFirstSubmit);


    const courseData = getCourseData.map(course => {
      const selectedUsers = selectedUserOptions[course.course_id] || [];

      let user_ids = [];

      if (selectedUsers.length > 0) {
        user_ids = selectedUsers.map(user => {
          // get full faculty details using fac_id
          const fullDetails = facultyMap[user.fac_id] || {};

          return {
            user_id: user.value,
            fac_id: user.fac_id,

            // append full faculty details inside user_ids[]
            ...fullDetails
          };
        });
      } else {
        user_ids = [];
      }

      return {
        course_id: course.course_id,
        course_type: course.college_course_type,
        user_ids: user_ids
      };
    }); // Skip empty

    const payload = {
      admYear: admissionYear.value,
      semester: semester_id.value,
      discipline: disciplineId,
      courseData: courseData,
     
    };
    const saveUserDataForSeat = () => {

      http.post('/College/mapCollegeTeacher', payload).then((response) => {
        if (response.data.status_code === 'MSG1') {

          setissaved(!issaved);
          toast.success('Data saved successfully');


        } else {
          toast.error('Failed to save data');
          setissaved(!issaved);

        }
      }).catch((error) => {
        setissaved(!issaved);

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 5000);
        } else {
          //toast.error(message);
          toast.error("Something went wrong");
        }
      });
    };
    saveUserDataForSeat();

  };

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    //window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };


  const handleGeneratePDFNew = async (discipline_id, disciplineName) => {
    // setLoading(true);
    try {
      const response = await http.get('/College/pdf_download', {
        params: {
          college_id: cid,
          admissionyear: admissionYear.value,
          semester_id: semester_id.value,
          discipline_id: discipline_id,
          course_type: courseDiciplineTypeData
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${disciplineName}_TeacherCourseMapping.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/sfa/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Teacher Course Mapping</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="card-body">
                        <div className="row justify-content-center">
                          <div className="col-md-12 mb-4">
                            <div className="row">
                              <div className="col-md-6">
                                <label>Admission Year <span className="errorclr">*</span></label>
                                <Select
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  id="admyear"
                                  name="admyear"
                                  className="form"
                                  styles={customStyles}
                                  options={admissionYears}
                                  value={admissionYear}
                                  onChange={handleAdmissionYearChange}
                                />
                              </div>

                              <div className="col-md-6">
                                <label>Semester <span className="errorclr">*</span></label>
                                <Select
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  id="semester_id"
                                  name="semester_id"
                                  className="form"
                                  styles={customStyles}
                                  options={[
                                    { value: 1, label: '1' },
                                    { value: 2, label: '2' },
                                    { value: 3, label: '3' },
                                    { value: 4, label: '4' }
                                  ]}
                                  value={semester_id}
                                  onChange={handleSemesterChange}
                                />
                              </div>
                              {/* 
                              <div className="col-md-4">
                                <label>Discipline <span className="errorclr">*</span></label>
                                <Select
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  id="discipline_id"
                                  name="discipline_id"
                                  className="form"
                                  styles={customStyles}
                                  onChange={handleDisciplineChange}
                                  options={flag
                                    ? [{ value: '0', label: 'No data found' }]
                                    : disciplinedata
                                      .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                      .map(disciplines => ({
                                        did: disciplines.discipline_id,
                                        value: disciplines.discipline_name,
                                        label: disciplines.discipline_name,
                                        type: disciplines.college_course_type
                                      }))
                                  }
                                  value={
                                    disciplinedata
                                      .map(d => ({
                                        did: d.discipline_id,
                                        value: d.discipline_name,
                                        label: d.discipline_name,
                                        type: d.college_course_type
                                      }))
                                      .find(option => option.did == disciplineId) || null
                                  }
                                />
                              </div> */}
                            </div>
                          </div>
                        </div>


                        <div className="row g-sm-3 height-equal-2 widget-charts">

                          {courseDiciplineNameData && courseDiciplineNameData.length > 0 ? (
                            <div className="txt-aln sfa-dis-headg">
                              <h5> Department/Discipline:  {courseDiciplineNameData}{collegeDiciplineSchemeID === 4 ? '(B.Voc)' : ''} {collegeDiciplineTypeData == 1 ? '- Single Faculty Course' : ''} </h5>
                            </div>
                          ) : (null

                          )}


                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Total Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.total_courses ? getCourseMappingStatusSummaryData.total_courses : '0'}</h5>
                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Mapped Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.mapped_courses ? getCourseMappingStatusSummaryData.mapped_courses : '0'}</h5>


                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Mapping Pending Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.pending_courses ? getCourseMappingStatusSummaryData.pending_courses : '0'}</h5>

                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>
                          {admissionYear && semester_id ? (
                            getCourseData && getCourseData.length > 0 ? (
                              <div>
                                {getEventMsg && (
                                  <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                    {/* <h6>The course mapping time is closed.</h6> */}
                                  </div>
                                )}

                                {/* <div className="txt-aln">
                                  <h5>Discipline: {courseDiciplineNameData || ''}</h5>
                                </div> */}
                                {semester_id.value !== activeSemesterId && (
                                  <div className="txt-aln">
                                    <p style={{ color: 'red', marginBottom: '10px' }}>The Course Mapping time is closed</p>

                                  </div>
                                )}
                                <div className="txt-aln-end">
                                  <button
                                    className="lbl2 btn btn-primary mt-3 mb-3"
                                    onClick={() => handleGeneratePDFNew(courseDiciplineIDData, courseDiciplineNameData)}
                                    title="Download"
                                  >
                                    <i class="bi bi-arrow-down-square"></i>
                                  </button>
                                </div>
                                <table className="table colap-table table-hover table-striped">
                                  <thead style={{ backgroundColor: "#f8f9fa", color: "#000" }}>
                                    <tr style={{ textAlign: "center" }}>
                                      <th className="bg-primary" width="50%">Courses</th>
                                      <th className="bg-primary">Name - UMS ID- Phone No.</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {getCourseData.map((course) => {
                                      const isEditable = semester_id.value === activeSemesterId;
                                      const isMapped = course.mapped === "mapped";
                                      const courseStatus = course.course_status;
                                      // Determine display text and styling
                                      let displayText = "Not Mapped";
                                      let textColor = "#856404"; // default for Not Mapped
                                      let bgColor = "#fff3cd"; // default for Not Mapped
                                      let borderColor = "#ffeeba"; // default for Not Mapped
                                      if (isMapped && courseStatus === "approved") {
                                        displayText = "Approved Mapping";
                                        textColor = "#155724"; // green
                                        bgColor = "#d4edda";
                                        borderColor = "#c3e6cb";
                                      } else if (isMapped) {
                                        displayText = "Mapped";
                                        textColor = "#004085"; // blue for mapped but not approved
                                        bgColor = "#cce5ff";
                                        borderColor = "#b8daff";
                                      }
                                      return (
                                        <tr key={course.course_id} style={{ textAlign: "center", verticalAlign: "middle", borderBottom: "1px solid #ddd" }}>
                                          <td>
                                            <input
                                              type="text"
                                              id={`course_id_${course.course_id}`}
                                              name={`course_id_${course.course_id}`}
                                              className="form-control ht"
                                              placeholder="Enter or view course..."
                                              value={course.avail_course}
                                              readOnly // always readOnly unless you want editable by isEditable
                                            />
                                            {course.signature == 1 && (
                                              <label
                                                style={{
                                                  display: 'block', // ensures it appears below the input
                                                  marginTop: '5px'
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    borderRadius: '4px',
                                                    padding: '2px 6px',
                                                    fontSize: '11px',
                                                    marginLeft: '6px'
                                                  }}
                                                >
                                                  Signature Course
                                                </span>
                                              </label>
                                            )}
                                            <div
                                              style={{
                                                marginTop: "5px",
                                                fontSize: "12px",
                                                padding: "3px 8px",
                                                borderRadius: "4px",
                                                display: "inline-block",
                                                color: textColor,
                                                backgroundColor: bgColor,
                                                border: `1px solid ${borderColor}`
                                              }}
                                            >
                                              {displayText}
                                            </div>
                                          </td>
                                          <td>
                                            <Select
                                              id={`user_id_${course.course_id}`}
                                              name={`user_id_${course.course_id}`}
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"
                                              options={getCollegeTeacherData.map(user => ({
                                                value: user.user_id,
                                                label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
                                                fac_id: user.fac_id,
                                              }))}
                                              value={selectedUserOptions[course.course_id] || null}
                                              onChange={(selectedOption) => {
                                                if (isEditable) {
                                                  handleUserChange(selectedOption, course.course_id);
                                                }
                                              }}
                                              isMulti
                                              //isDisabled={!isEditable}
                                              isDisabled={!isEditable || (isMapped && courseStatus === "approved")}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                <div>
                                  <p className="txt-aln" style={{ marginTop: '10px', fontSize: '12px', color: 'red' }}>
                                    Please note that after the Principal’s approval of the teacher–course mapping, no further modifications will be allowed.
                                  </p>
                                </div>
                                {/* Only show buttons if selected semester is active */}
                                {semester_id.value === activeSemesterId && (
                                  <div className="col-md-12 txt-aln p-50">
                                    <div>
                                      <button
                                        className="btn btn-primary me-3"
                                        type="submit"
                                        onClick={handlefirstsubmit}
                                      >
                                        Submit
                                      </button>
                                      <input
                                        className="btn btn-light"
                                        type="reset"
                                        value="Cancel"
                                        onClick={cancelForm}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center' }}>
                                <p>No data found</p>
                              </div>
                            )
                          ) : (
                            <div style={{ textAlign: 'center' }}>
                              <p>No data found</p>
                            </div>
                          )}

                          <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="modal-toggle-wrapper">
                                    <h4 className="text-center pb-2">Are you sure you want to save?</h4>
                                    <p className="txt-aln-jst">Please note that only courses mapped to a teacher in the SFA Panel will be available for students during course selection.</p>
                                    <div className="d-flex justify-content-center mt-3">
                                      <div>
                                        <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Save</button>
                                        <button
                                          className="btn"
                                          style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                          data-bs-dismiss="modal"
                                          onClick={handleCancel}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </Template>
    </>
  );
}
